<template>
  <div class="qr-container pulse">
    <div class="qr-modal">
      <div class="logo">
        <router-link to="/">
          <img
            :src="
              $store.state.system_settings['logo']
                ? $store.state.api_uploads_link +
                  $store.state.system_settings['logo']
                : ''
            "
            alt="Logo"
          />
        </router-link>
      </div>
      <div v-if="!hasUploaded && !gettingQRData" class="upload-container">
        <div class="file-type" v-if="fileType != ''">
          <div class="icon">
            <img :src="fileIcon" />
          </div>
          <div class="text">
            {{ fileName }}
            <div class="progress-container" v-if="isUploading">
              <div class="progress">
                <div class="bar" :style="{ width: progress + '%' }">
                  <div class="percent">
                    {{ isProcessing ? toLocal('qr.processing') : progress + "%" }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="clear"
            @click="isUploading ? cancelUpload() : resetFileData()"
          >
            <span></span><span></span>
          </div>
        </div>
        <button
          v-if="qrIsValid && fileType == ''"
          class="btn btn-info"
          @click="$refs.fileInput.click()"
          :class="{ pulse: fileType != '' }"
        >
          <svg            xmlns="http://www.w3.org/2000/svg"            width="102.711"            height="83.527"            viewBox="0 0 102.711 83.527"          >            <g              id="Group_516"              data-name="Group 516"              transform="translate(1.75 1.75)"            >              <g                id="Group_510"                data-name="Group 510"                transform="translate(32.898 17.486)"              >                <g                  id="Group_509"                  data-name="Group 509"                  transform="translate(0 9.8)"                >                  <g id="Group_508" data-name="Group 508">                    <path                      id="Path_693"                      data-name="Path 693"                      d="M299.733,1765.324v10.518a5.185,5.185,0,0,1-5.178,5.179H269.2a5.185,5.185,0,0,1-5.178-5.179v-10.689"                      transform="translate(-264.026 -1765.153)"                      fill="none"                      stroke="#707070"                      stroke-linecap="round"                      stroke-miterlimit="10"                      stroke-width="3.5"                    />                  </g>                </g>                <line                  id="Line_48"                  data-name="Line 48"                  y1="18.869"                  transform="translate(17.825)"                  fill="none"                  stroke="#707070"                  stroke-linecap="round"                  stroke-miterlimit="10"                  stroke-width="3.5"                />                <path                  id="Path_694"                  data-name="Path 694"                  d="M283.277,1754.806l4.564-4.563a1.282,1.282,0,0,1,1.813,0l4.367,4.366"                  transform="translate(-270.935 -1749.867)"                  fill="none"                  stroke="#707070"                  stroke-linecap="round"                  stroke-miterlimit="10"                  stroke-width="3.5"                />              </g>              <g                id="Group_515"                data-name="Group 515"                transform="translate(0 0)"              >                <rect                  id="Rectangle_297"                  data-name="Rectangle 297"                  width="99.211"                  height="60.069"                  rx="5.669"                  fill="none"                  stroke="#707070"                  stroke-linecap="round"                  stroke-miterlimit="10"                  stroke-width="3.5"                />                <rect                  id="Rectangle_298"                  data-name="Rectangle 298"                  width="31.197"                  height="13.37"                  transform="translate(34.685 60.069)"                  fill="none"                  stroke="#707070"                  stroke-linecap="round"                  stroke-miterlimit="10"                  stroke-width="3.5"                />                <rect                  id="Rectangle_299"                  data-name="Rectangle 299"                  width="46.311"                  height="6.394"                  rx="2.835"                  transform="translate(27.128 73.633)"                  fill="none"                  stroke="#707070"                  stroke-linecap="round"                  stroke-miterlimit="10"                  stroke-width="3.5"                />              </g>            </g>          </svg>
          {{ fileType == "" ? toLocal('qr.select_file') : toLocal('qr.upload_file') }}
        </button>

        <input
          ref="camera"
          type="file"
          style="display: none"
          name="image"
          accept="image/*"
          capture="environment"
          @change="selectFile"
        />
        <button
          v-if="qrIsValid && fileType == ''"
          class="btn btn-info camera-btn"
          @click="$refs.camera.click()"
          :class="{ pulse: fileType != '' }"
        >
          {{toLocal('qr.open_camera')}}
        </button>
        <input
          type="file"
          style="display: none"
          ref="fileInput"
          capture="environment"
          accept=".mp4,.mp3,.pdf,.pptx,.xlsx,.docx,.ppt,.xls,.doc,.png,.jpg,.jpeg,.m4a,.wav,.aac,.3gp,.amr,.odp,.ods,.odt,.webm,.gif,.bmp,.heic,.heif"
          @change="selectFile"
        />
        <div class="error">
          {{ errorMessage }}
        </div>
        <button
          v-if="!qrIsValid"
          class="btn btn-info"
          @click="$router.replace({ path: '/login' })"
          :class="{ pulse: fileType != '' }"
        >
          {{toLocal('generic.login')}}
        </button>
      </div>
      <div v-else-if="hasUploaded && !gettingQRData" class="success-container">
        {{toLocal('qr.success_text')}}
      </div>
      <div v-else>
        <font-awesome-icon icon="spinner" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      progress: 0,
      isUploading: false,
      uploadedData: null,
      axiosUploadController: null,
      hasUploaded: false,
      errorMessage: "",
      fileName: "",
      fileExtension: "",
      imageFileExtensions: ["png", "jpg", "jpeg", "gif", "bmp", "heic", "heif"],
      documentFileExtensions: [
        "pdf",
        "pptx",
        "xlsx",
        "docx",
        "ppt",
        "xls",
        "doc",
        "odp",
        "ods",
        "odt",
      ],
      audioFileExtensions: ["mp3", "m4a", "wav", "aac"],
      videoFileExtensions: ["mp4", "3gp", "amr", "webm"],
      selectedFile: null,
      fileType: "",
      fileTypes: [],
      qrData: null,
      qrIsValid: false,
      gettingQRData: true,
      isProcessing: false,
    };
  },
  computed: {
    qrCode() {
      return this.$route.params.qr;
    },
    fileIcon() {
      let fileType = this.fileTypes.find((type) => type.name == this.fileType);
      return fileType ? fileType.icon : "";
    },
  },
  watch: {
    progress() {
      if (this.progress == 100 && this.isUploading) {
        this.isProcessing = true;
      }
    },
  },

  mounted() {
    this.getQrData();
  },

  methods: {
    getQrData() {
      this.gettingQRData = true;
      axios
        .get(
          `${this.$store.state.api_link}/qr/${this.qrCode}`,
          this.$store.getters.axiosConfig()
        )
        .then((response) => {
          if (response.data.status == "error") {
            this.qrIsValid = false;
            this.errorMessage = this.toLocal('qr.qr_is_invalid');
          } else {
            this.qrData = response.data.data;
            this.qrIsValid = true;
          }
          this.gettingQRData = false;
        })
        .catch((error) => {
          console.log(error);
          this.qrIsValid = false;
          this.errorMessage = this.toLocal('qr.qr_is_invalid');
          this.gettingQRData = false;
        });
    },
    getFileExtension(filename) {
      return filename.split(".").pop();
    },
    resetFileData() {
      this.selectedFile = null;
      this.fileExtension = "";
      this.fileName = "";
      this.fileType = "";
    },
    selectFile(e) {
      var file;
      if (e.size) {
        file = e;
      } else {
        let files = e.target.files || e.dataTransfer.files;

        if (!files.length) return;
        file = files[0];
      }
      this.resetFileData();
      this.fileExtension = this.getFileExtension(file.name);
      this.fileName = file.name.split(/(\\|\/)/g).pop();
      this.fileType = this.getFileType(this.fileExtension);
      this.selectedFile = file;
      this.uploadFile();
    },
    uploadFile() {
      this.errorMessage = "";
      let formData = new FormData();
      try {
        let file = this.selectedFile;
        this.isUploadingFile = true;
        formData.append("file", file);
        formData.append("QRCode", this.qrCode);
        this.axiosUploadController = new AbortController();
        this.progress = 0;
        this.isUploading = true;
      } catch (e) {
        console.log(e);
        this.errorMessage = this.toLocal('qr.errpr');
      }
      axios
        .post(`${this.$store.state.api_link}/upload-file/qr`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            this.uploadedData = progressEvent.loaded;
            this.progress = parseInt(
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            );
          },
          signal: this.axiosUploadController.signal,
        })
        .then((response) => {
          this.isUploadingFile = false;
          // if(response.data.status == 'success'){
          // }
          this.hasUploaded = true;
          this.isUploading = false;
          this.isProcessing = false;
          setTimeout(() => {
            this.$router.replace({ path: "/login" });
          }, 3000);
        })
        .catch((error) => {
          console.log(error);
          this.isUploadingFile = false;
          this.isUploading = false;
          this.isProcessing = false;
        });
    },
    getFileType() {
      if (this.audioFileExtensions.includes(this.fileExtension)) {
        return "audio";
      } else if (this.videoFileExtensions.includes(this.fileExtension)) {
        return "video";
      } else if (this.documentFileExtensions.includes(this.fileExtension)) {
        return "document";
      } else if (this.imageFileExtensions.includes(this.fileExtension)) {
        return "image";
      } else {
        return "other";
      }
    },
    cancelUpload() {
      if (this.axiosUploadController) {
        this.axiosUploadController.abort();
        this.isUploadingFile = false;
        this.isUploading = false;
        this.resetFileData();
      }
    },
    hasGetUserMedia() {
      return !!(
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        navigator.msGetUserMedia
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh !important;
  background: #efefef;
  // background: linear-gradient(153deg, rgb(255, 255, 255) 0%, rgba(40,52,92,0.1558824213279062) 78%);
  // background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  // background-size: 400% 400%;
  // animation: gradient 5s ease infinite;
}
@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.qr-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 1rem;
  max-width: calc(100vw - 40px);
  border-radius: 20px;
  box-shadow: 0px 0px 4px 1px rgb(167, 167, 167);
}
.pulse {
  animation: pulse 2s ease infinite;
}
@keyframes pulse {
  0% {
    box-shadow: 0px 0px 4px 1px rgb(167, 167, 167);
  }
  50% {
    box-shadow: 0px 0px 14px 1px #0000001f;
  }
  100% {
    box-shadow: 0px 0px 4px 1px rgb(167, 167, 167);
  }
}
button {
  display: flex;
  justify-content: center;
  border: none;
  background: var(--primary-color);
  color: white;
  border-radius: 20px;
  padding: 8px 2rem;
  font-size: 1.2rem;
  width: 100%;
  cursor: pointer;
}
.progress-container {
  display: flex;
  align-items: center;
  position: absolute;
  left: -5px;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.file-type {
  display: flex;
  position: relative;
  width: 100%;
  border: 1px solid var(--primary-color);
  border-radius: 5px;
  // padding: 5px 10px;
  margin-bottom: 1rem;
  .icon {
    display: flex;
    z-index: 2;
  }
  img {
    background: var(--primary-color);
    border-radius: 5px;
    padding: 5px;
    max-height: 50px;
  }
  .text {
    display: flex;
    position: relative;
    padding: 5px 15px;
    max-width: 350px;
    color: var(--primary-color);
    font-size: 16px;
    min-width: 300px;
  }
  .clear {
    display: flex;
    position: relative;
    width: 60px;
    padding: 0 15px;
    border-left: 1px solid var(--primary-color);
    cursor: pointer;
    span {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      width: 3px;
      height: 80%;
      margin: auto;
      background: var(--primary-color);
      color: white;
      border-radius: 15px;
      transform: rotate(45deg);
      transition: transform 0.3s;
      cursor: pointer;
    }
    span:last-child {
      transform: rotate(-45deg);
    }
    &:hover {
      span {
        transform: scale(1.1) rotate(40deg);
      }
      span:last-child {
        transform: scale(1.1) rotate(-40deg);
      }
    }
  }
  @media(max-width: 768px), (max-width: 1000px) and (max-height: 512px) {
    .text {
      display: block;
      flex: 5;
      overflow: hidden;
      text-overflow: ellipsis;
      min-width: 10%;
      white-space: nowrap;
    }
  }
}
.btn {
  display: flex;
  align-items: center;
  svg {
    max-height: 30px;
    max-width: 30px;
    margin-right: 0.5rem;
    path,
    rect,
    line {
      stroke: white;
    }
  }
  &.camera-btn {
    margin-top: 1rem;
  }
}
.progress {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-align: center;
  margin: 1rem 0;
  overflow: hidden;
  height: 100%;
  .bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 0px;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: #a9b9ee;
    transition: width 0.3s;
    .percent {
      position: relative;
      right: 10px;
      font-weight: 700;
      font-size: clamp(12px, 5vw, 20px);
    }
  }
}
.error {
  margin: 0.5rem 0;
}
.button_outer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  min-width: 30px;
  border: 2px solid var(--primary-color);
  cursor: pointer;
  span {
    position: absolute;
    width: 80%;
    height: 2px;
    background: var(--primary-color);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    transform: rotate(45deg);
    &:last-child {
      transform: rotate(-45deg);
    }
  }
}
.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.progress-container {
  width: calc(100% + 5px);
}
.logo {
  display: flex;
  justify-content: center;
  width: 10vw;
  max-width: 250px;
  min-width: 150px;
  margin-bottom: 1rem;
  a {
    display: flex;
    width: 100%;
    img {
      width: 100%;
    }
  }
}
.text-container {
  display: flex;
  width: 100%;
}
</style>
